@if (document) {
  <mat-card>
    <div class="double-header">
      <mat-card-title>{{document.modifiedBy}}</mat-card-title>
      <mat-card-title>{{document.modifiedDate | date}}</mat-card-title>
    </div>
    <mat-card-content>
      @if (document.comment) {
        <p>{{document.name}} - Revision {{document.revision}} - {{document.comment}}</p>
      }
      @if (!document.comment) {
        <p>{{document.name}} - Revision {{document.revision}}</p>
      }
    </mat-card-content>
  </mat-card>
}

@if (!document) {
  <mat-card>
    <div class="double-header">
      <mat-card-title>{{title}}</mat-card-title>
    </div>
    <mat-card-content>
      <p>Select a release definition and revision to start comparing</p>
    </mat-card-content>
  </mat-card>
}